var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightbulb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5369_67097",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5369_67097)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 16.5C8.675 16.5 8.38125 16.4219 8.11875 16.2656C7.85625 16.1094 7.65 15.9 7.5 15.6375C7.0875 15.6375 6.73438 15.4906 6.44063 15.1969C6.14688 14.9031 6 14.55 6 14.1375V11.475C5.2625 10.9875 4.67188 10.3438 4.22812 9.54375C3.78438 8.74375 3.5625 7.875 3.5625 6.9375C3.5625 5.425 4.09062 4.14062 5.14687 3.08437C6.20312 2.02812 7.4875 1.5 9 1.5C10.5125 1.5 11.7969 2.02812 12.8531 3.08437C13.9094 4.14062 14.4375 5.425 14.4375 6.9375C14.4375 7.9 14.2156 8.775 13.7719 9.5625C13.3281 10.35 12.7375 10.9875 12 11.475V14.1375C12 14.55 11.8531 14.9031 11.5594 15.1969C11.2656 15.4906 10.9125 15.6375 10.5 15.6375C10.35 15.9 10.1438 16.1094 9.88125 16.2656C9.61875 16.4219 9.325 16.5 9 16.5ZM7.5 14.1375H10.5V13.4625H7.5V14.1375ZM7.5 12.7125H10.5V12H7.5V12.7125ZM7.35 10.5H8.4375V8.475L6.7875 6.825L7.575 6.0375L9 7.4625L10.425 6.0375L11.2125 6.825L9.5625 8.475V10.5H10.65C11.325 10.175 11.875 9.69688 12.3 9.06563C12.725 8.43438 12.9375 7.725 12.9375 6.9375C12.9375 5.8375 12.5563 4.90625 11.7938 4.14375C11.0312 3.38125 10.1 3 9 3C7.9 3 6.96875 3.38125 6.20625 4.14375C5.44375 4.90625 5.0625 5.8375 5.0625 6.9375C5.0625 7.725 5.275 8.43438 5.7 9.06563C6.125 9.69688 6.675 10.175 7.35 10.5Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/lightbulb.4212878688a9460e1eb0f4768793cc92.svg";
export { ForwardRef as ReactComponent };